import axios from 'axios'

export const ajax = axios.create({
    baseURL: "https://kajimidididi.com:8080",
})
/**
 *
 * 请求拦截器
 */
ajax.interceptors.request.use(

)
/**
 *
 * 响应拦截器
 */
ajax.interceptors.response.use(

)
